import React from "react";
import { Box } from "@mui/material";

import { HolidayCalendarSetting } from "./CalendarVersion/HolidayCalendarSetting";

// eslint-disable-next-line import/prefer-default-export
export function HolidaySettings(): React.ReactNode {
  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <Box sx={{ flex: 1, overflow: "hidden" }}>
        <HolidayCalendarSetting />
      </Box>
    </Box>
  );
}
